module.exports = __webpack_public_path__ + "img/5b02001.webp";